import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';


const TrustSignals = () => {
  const securityFeatures = [
  {
    icon: 'Shield',
    title: 'SSL Encrypted',
    description: '256-bit encryption'
  },
  {
    icon: 'Lock',
    title: 'SOC 2 Compliant',
    description: 'Type II certified'
  },
  {
    icon: 'CheckCircle2',
    title: 'GDPR Ready',
    description: 'EU data protection'
  },
  {
    icon: 'Award',
    title: 'ISO 27001',
    description: 'Security certified'
  }];


  const testimonials = [
  {
    name: 'Sarah Chen',
    role: 'Startup Founder',
    company: 'TechVenture Inc.',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13677ef73-1763293657301.png",
    avatarAlt: 'Professional headshot of Asian woman with long black hair wearing navy blazer and white blouse smiling confidently',
    content: 'This platform cut our MVP development time from 3 months to 2 weeks. The generated code was production-ready and saved us over $50,000 in development costs.',
    rating: 5
  },
  {
    name: 'Michael Rodriguez',
    role: 'Senior Developer',
    company: 'DevSolutions LLC',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13e314ecd-1763294694902.png",
    avatarAlt: 'Professional headshot of Hispanic man with short black hair wearing dark suit and tie with warm smile',
    content: 'As a developer, I was skeptical at first. But the code quality exceeded my expectations—clean architecture, proper error handling, and excellent documentation throughout.',
    rating: 5
  },
  {
    name: 'Emily Thompson',
    role: 'Product Manager',
    company: 'InnovateCo',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1456eb2f9-1763294356174.png",
    avatarAlt: 'Professional headshot of Caucasian woman with blonde hair in business casual attire with friendly expression',
    content: 'We use this for rapid prototyping with clients. Being able to generate working demos in minutes has transformed our sales process and client presentations.',
    rating: 5
  }];


  const codeQualityMetrics = [
  { label: 'Code Coverage', value: '95%', icon: 'Target' },
  { label: 'Performance Score', value: '98/100', icon: 'Gauge' },
  { label: 'Security Rating', value: 'A+', icon: 'ShieldCheck' },
  { label: 'Maintainability', value: 'Excellent', icon: 'Wrench' }];


  return (
    <section className="py-12 md:py-20 lg:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4 lg:mb-5">
            Trusted by Developers Worldwide
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Enterprise-grade security and code quality standards you can rely on.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 lg:gap-8 mb-12 md:mb-16 lg:mb-20">
          {securityFeatures?.map((feature, index) =>
          <div
            key={index}
            className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 text-center hover:border-primary/50 transition-all duration-300">

              <div className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-3 md:mb-4 lg:mb-5">
                <Icon name={feature?.icon} size={20} className="text-primary" />
              </div>
              <h3 className="text-sm md:text-base lg:text-lg font-semibold text-foreground mb-1 md:mb-2">
                {feature?.title}
              </h3>
              <p className="text-xs md:text-sm lg:text-base text-muted-foreground">
                {feature?.description}
              </p>
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8 mb-12 md:mb-16 lg:mb-20">
          {codeQualityMetrics?.map((metric, index) =>
          <div
            key={index}
            className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 text-center">

              <Icon name={metric?.icon} size={24} className="text-accent mx-auto mb-2 md:mb-3 lg:mb-4" />
              <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-1 md:mb-2">
                {metric?.value}
              </div>
              <div className="text-xs md:text-sm lg:text-base text-muted-foreground">
                {metric?.label}
              </div>
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
          {testimonials?.map((testimonial, index) =>
          <div
            key={index}
            className="bg-card border border-border rounded-xl p-5 md:p-6 lg:p-7 hover:border-primary/50 transition-all duration-300 hover:shadow-lg hover:shadow-primary/10">

              <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-5 lg:mb-6">
                <Image
                src={testimonial?.avatar}
                alt={testimonial?.avatarAlt}
                className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-full object-cover" />

                <div className="flex-1 min-w-0">
                  <h4 className="text-sm md:text-base lg:text-lg font-semibold text-foreground truncate">
                    {testimonial?.name}
                  </h4>
                  <p className="text-xs md:text-sm lg:text-base text-muted-foreground truncate">
                    {testimonial?.role}
                  </p>
                  <p className="text-xs md:text-sm text-muted-foreground truncate">
                    {testimonial?.company}
                  </p>
                </div>
              </div>

              <div className="flex gap-1 mb-3 md:mb-4 lg:mb-5">
                {[...Array(testimonial?.rating)]?.map((_, i) =>
              <Icon key={i} name="Star" size={16} className="text-amber-500 fill-amber-500" />
              )}
              </div>

              <p className="text-sm md:text-base lg:text-lg text-muted-foreground leading-relaxed">
                "{testimonial?.content}"
              </p>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default TrustSignals;